import DateColumn from './DateColumn';
import type { DateColumnProps } from './types';

export default DateColumn;
export type { DateColumnProps };
